import $ from 'jquery';

import Component from '../Component';

/** Pagination logic (Infinite scrolling and Load more button) */
export default class Pagination extends Component {
  // how many pixels from bottom should next page start loading
  PAGINATION_LOAD_OFFSET = 1200;
  // how often should the scroll position should be checked (in milliseconds)
  SCROLL_DELAY = 200;

  PAGINATION_SELECTOR = '.pagination';
  COLLECTION_WRAPPER_SELECTOR = '.wrapper.main-content';
  COLLECTION_MAIN_SELECTOR = '.collection-main-body-inner';
  COLLECTION_HEADER_SELECTOR = '.collection-main-central-header';
  COLLECTION_ITEM_SELECTOR = '.grid__item';
  COLLECTION_ITEM_EXCLUDE_SELECTOR = '.collection-central-description-block';

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element, loadedCallback) {
    super(theme, element);
    this.loadedCallback = loadedCallback;
    this.$w = $(window);
    this.$doc = $(document);
    this.$self = this;
    this.$collection = $(this.COLLECTION_MAIN_SELECTOR);
    this.$wrapper = $(this.COLLECTION_WRAPPER_SELECTOR);
    this.$loading_indicator = $('.pagination-loading');
    this.loading = false;
    this.fully_loaded = false;
    this.scroll_timeout = null;
    this.pagination_type = null;

    // If neither "infinite scrolling" nor "load more" are enabled, end function here
    const $pagination_infinite = $('.pagination-infinite');
    const $pagination_load_more = $('.pagination--load-more');

    if ($pagination_infinite.length === 0 && $pagination_load_more.length === 0) {
      return;
    }
    this.initialize();
  }

  initialize = () => {
    if ($('.pagination').hasClass('pagination-infinite')) {
      this.pagination_type = 'infinite-scroll';

    } else if ($('.pagination').hasClass('pagination--load-more')) {
      this.pagination_type = 'load-more';

      this.load_more_button();
    }
  }

  onWindowScroll = () => {
    if (this.pagination_type !== 'infinite-scroll') {
      return;
    }

    var height = this.$wrapper.position().top + this.$wrapper.height();
    if (height - this.PAGINATION_LOAD_OFFSET < (this.$doc.scrollTop() + this.$w.height())) {
      this.load_next_page();
    }
  };

  check_pagination_progress = () => {
    var next_url = $(this.PAGINATION_SELECTOR).find('.pagination-next a').attr('href');
    this.fully_loaded = (!next_url || next_url === '#');
  };

  build_load_more_html = function () {
    var totalItems = parseInt($('.pagination').attr('data-paginate-items'), 10);
    var currentOffset = parseInt($('.pagination').attr('data-paginate-offset'), 10);
    var pageSize = parseInt($('.pagination').attr('data-paginate-size'), 10);
    var totalViewed = currentOffset + pageSize;
    var progressPercentage = (100 * totalViewed) / totalItems;
    if (this.theme.translations.youve_viewed !== undefined) {
        var youViewed = this.theme.translations.youve_viewed.replace('{{ x }}', totalViewed).replace('{{ y }}', totalItems);
    }
    else {
        youViewed = "";
    }

    var buttonHtml = '<div class="pagination__load-more">' +
                        `<p class="pagination__progress-text">${youViewed}</p>` +
                        '<div class="progress-bar"><div class="progress-bar__inner" style="width:' +
                        progressPercentage +
                        '%;"></div></div>' +
                        `<button class="btn btn--large btn--load-more">${this.theme.translations.load_more}</button>` +
                    '</div>';

    return buttonHtml;
  };

  load_more_button = function () {
    this.check_pagination_progress();

    // Check if Load More button already on page
    var buttonAppended = $('.pagination .btn--load-more').length !== 0;

    // Build Button html
    var buttonHtml = this.build_load_more_html();

    // If button not on page and more results are available, display button
    if  (!buttonAppended && !this.fully_loaded) {
      $('.pagination').append(buttonHtml);
    }

    // If button clicked, load next page
    $('.btn--load-more').off('click').on('click', this.load_next_page.bind(this.$self));
  };

  set_loading = function (loading) {
    if (loading) {
      this.loading = true;
      this.$loading_indicator.show();
      $(this.PAGINATION_SELECTOR).hide();
    } else {
      this.loading = false;
      this.$loading_indicator.hide();
      $(this.PAGINATION_SELECTOR).show();
    }
  };

  load_next_page = () => {
    if (this.loading) {
      return false;
    }
    var next_url = $(this.PAGINATION_SELECTOR).find('.pagination-next a').attr('href');
    if (!next_url || next_url === '#') {
      return;
    }
    this.set_loading(true);
    $.ajax({
      type: 'GET',
      url: next_url,
      dataType: "html"
    })
      .then(this.page_loaded.bind(this))
      .always(this.set_loading.bind(this, false));
  };

  page_loaded = (data) => {
    var data_dom = $(data);
    var classes = $('#grid_item_width_classes').val();
    if (classes) {
      data_dom.find('.grid__item').removeClass('large--one-quarter medium--one-quarter small--one-whole large--one-half medium--one-half').addClass(classes);
    }
    this.$collection.append(
      data_dom.find(this.COLLECTION_HEADER_SELECTOR + ' > ' + this.COLLECTION_ITEM_SELECTOR).not(this.COLLECTION_ITEM_EXCLUDE_SELECTOR),
      data_dom.find(this.COLLECTION_MAIN_SELECTOR + ' > ' + this.COLLECTION_ITEM_SELECTOR)
    );
    $(this.PAGINATION_SELECTOR).replaceWith(data_dom.find(this.PAGINATION_SELECTOR));

    // If "load more" enabled, run function to conditionally render button on newly-loaded page
    if (this.pagination_type === 'load-more') {
      this.load_more_button();
    }

    if (this.loadedCallback) {
      this.loadedCallback();
    }
  };
}
